import i18n from 'i18n/config';

export default {
  PENDING: {
    value: 'PENDING',
    text: i18n.t('BoardStatusLabelPending'),
    style: 'badge-light',
    icon: 'ni ni-clock',
    label: 'Pending',
  },
  ACTIVE: {
    value: 'ACTIVE',
    text: i18n.t('BoardStatusLabelConvocated'),
    style: 'badge-primary',
    icon: 'ni ni-check-circle',
    label: 'Convocated',
  },
  CLOSED: {
    value: 'CLOSED',
    text: i18n.t('BoardStatusLabelClosed'),
    style: 'badge-success',
    icon: 'ni ni-na',
    label: 'Closed',
  },
  CANCELED: {
    value: 'CANCELED',
    text: i18n.t('BoardStatusLabelCanceled'),
    style: 'badge-secondary',
    icon: 'ni ni-cross',
    label: 'Canceled',
  },
};
